import React from "react";

interface HowToReadProps {
  title: string;
  image: string;
}

const HowToRead: React.FC<HowToReadProps> = ({ title, image }) => {
  return (
    <div className="">
      <div className="px-4 text-base font-semibold text-text-primary mb-2">
        {title}
      </div>
      <img src={image} alt="how to read" className="w-[80%] h-auto" />
    </div>
  );
};

export default HowToRead;
